import { render, staticRenderFns } from "./CheckoutView.vue?vue&type=template&id=63107aab"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiCheckoutAddressComponent: require('/home/node/app/components/ui/checkout/addressComponent.vue').default,UiCheckoutDeliveryComponent: require('/home/node/app/components/ui/checkout/deliveryComponent.vue').default,UiCheckoutPaymentComponent: require('/home/node/app/components/ui/checkout/paymentComponent.vue').default,ControllerCart: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCart.js').default})
